"use strict";

var _useFleetQuoteUrl_Query;
import { encode } from 'qss';
import { useLazyLoadQuery } from 'react-relay/hooks';
import { graphql } from 'relay-runtime';
export const useFleetQuoteUrl = ({
  id,
  make,
  model,
  location
}) => {
  const {
    fleetCompany
  } = useLazyLoadQuery(_useFleetQuoteUrl_Query !== void 0 ? _useFleetQuoteUrl_Query : _useFleetQuoteUrl_Query = require("../../../../../packages/relay/__generated__/useFleetQuoteUrl_Query.graphql"), {
    id
  });
  return `${fleetCompany.quoteUrl}&${encode({
    Make: make ? make.slug : void 0,
    Model: model ? model.slug : void 0,
    SuburbId: location ? location.suburbId : void 0,
    Latitude: location ? location.latitude || void 0 : void 0,
    Longitude: location ? location.longitude || void 0 : void 0
  })}`;
};